import { MAX_USERNAME_LENGTH } from "../Enum/EnvironmentVariable";

export type LayerNames = "woka" | "body" | "eyes" | "hair" | "clothes" | "hat" | "accessory";

export interface CharacterTexture {
    id: string;
    layer: LayerNames;
    url: string;
}

export const maxUserNameLength: number = MAX_USERNAME_LENGTH;

// \S nao basta: existem caracteres que nao sao espaco pra regex mas nao desenham nada -
// o braille blank (U+2800) e o caso que apareceu aqui, usado pra entrar com o nome
// invisivel. Tambem entram os espacos exoticos, os controles de direcao de texto e os
// juntadores de largura zero. Exige-se pelo menos um caractere que de fato apareca.
const INVISIVEIS = /[\s\u00a0\u1680\u180e\u2000-\u200f\u2028-\u202f\u205f-\u206f\u2800\u3000\ufeff]/gu;

export function hasVisibleCharacter(value: string): boolean {
    return value.replace(INVISIVEIS, "").length > 0;
}

export function isUserNameValid(value: unknown): boolean {
    return (
        typeof value === "string" &&
        value.length > 0 &&
        value.length <= maxUserNameLength &&
        hasVisibleCharacter(value)
    );
}

export function isUserNameTooLong(value: unknown): boolean {
    return typeof value === "string" && value.length > 0 && value.length > maxUserNameLength;
}

export function areCharacterTexturesValid(value: string[] | null): boolean {
    if (!value || !value.length) {
        return false;
    }
    for (const layerName of value) {
        if (layerName.length === 0 || layerName === " ") {
            return false;
        }
    }
    return true;
}
